module.exports = __webpack_public_path__ + "img/sondeo_territorial.647cb00c.jpg";